var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"size":"is-large"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("Bitbucket")])
}
var staticRenderFns = []

export { render, staticRenderFns }